export async function loadExcelJS() {
    const module = await import("exceljs/dist/exceljs.min.js");
    return module.default || module;
}
